core-tabs-vertical {
  display: block;
}

.core-tabs--vertical {
  display: flex;
  flex-direction: row;
}

.core-tabs--vertical .core-tabs-list {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0;
  margin: 0;
  border-bottom: none;
  list-style: none;
}

.core-tabs--vertical .core-tabs-list.core-tabs-list--small {
  width: 12.5rem; /* 200px */
}
.core-tabs--vertical .core-tabs-list.core-tabs-list--medium {
  width: 17.5rem; /* 280px */
}
.core-tabs--vertical .core-tabs-list.core-tabs-list--large {
  width: 22.5rem; /* 360px */
}

.core-tabs--vertical .tab-content {
  flex-grow: 1;
  padding-top: 0px;
}

.core-tabs--vertical .core-tab-item {
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  min-width: 7.5rem;
  border-radius: var(--number-radius-medium);
  padding: var(--number-spacing-small) 0;
  background-color: var(--color-selection-secondary-background-default);
  color: var(--color-selection-secondary-content-default);
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
  color var(--motion-duration-fast) var(--motion-easing-move);
}

.core-tabs--vertical .tab-item--stretch {
  flex-grow: 1;
}

.core-tabs--vertical .tab-item--disabled {
  cursor: not-allowed;
  color: var(--color-global-all-disabled-strong)
}

.core-tabs--vertical .tab-item--selected {
  position: relative;
  background-color: var(--color-selection-secondary-background-selected);
  color: var(--color-selection-secondary-content-selected);
}

.core-tabs--vertical .core-tab-item  .tab-label-content {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0 var(--number-spacing-small);
  gap: var(--number-spacing-4xsmall);
  width: 100%;
}

.core-tabs--vertical .tab-item--selected .tab-label-content::after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  height: 100%;
  width: 2px;
  margin-right: var(--number-spacing-small); /* padding bottom minus indicator width */
  background-color: var(--color-selection-secondary-content-selected);
}

.core-tabs--vertical .tab-label-content .tab-label {
  flex-grow: 1;
}

.core-tabs--vertical .core-tab-item:focus-visible {
  outline: 2px solid var(--color-global-border-focus);
  z-index: 1000; /* make sure outline is always on top of sibling elements */
}

.core-tabs--vertical .core-tab-item:not(.tab-item--disabled):not(.tab-item--selected):hover, .core-tabs--vertical .core-tab-item:not(.tab-item--disabled):not(.tab-item--selected):focus-visible {
  background-color: var(--color-selection-secondary-background-interacting);
  color: var(--color-selection-secondary-content-interacting);
}

.core-tabs--vertical .core-tab-item {
  min-width: 7em;
}
